import "core-js/modules/web.dom.iterable";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import Prismic from 'prismic-javascript';
import { logError } from '@/helpers/log-helper';

function getRef(context, api) {
  const previewRef = context.$cookies.get(Prismic.previewCookie);
  const masterRef = api.refs.find(ref => ref.isMasterRef === true).ref;
  return previewRef || masterRef;
}

function fetchArticlesByTag(_x, _x2, _x3, _x4) {
  return _fetchArticlesByTag.apply(this, arguments);
}

function _fetchArticlesByTag() {
  _fetchArticlesByTag = _asyncToGenerator(function* (context, params, page, pageSize) {
    const locale = context.state.i18n.currentLocale;

    try {
      const query = [Prismic.Predicates.at('document.type', 'article')];

      if (params) {
        query.push(Prismic.Predicates.at('document.tags', params.tags));
      }

      const endPoint = context.state.sharedEnv.payload.prismic;
      const api = yield Prismic.getApi(endPoint);
      const ref = getRef(context, api);
      const response = api.query(query, _objectSpread({
        fetch: ['article.image', 'article.date', 'article.description', 'article.main_title', 'article.reading_time', 'article.difficulty']
      }, pageSize && {
        pageSize
      }, page && {
        page
      }, {
        orderings: '[my.article.date desc]',
        lang: locale.iso ? locale.iso.toLowerCase() : '',
        ref
      }));
      return response;
    } catch (e) {
      logError({
        msg: e,
        context
      });
      return null;
    }
  });
  return _fetchArticlesByTag.apply(this, arguments);
}

function fetchContent(_x5, _x6) {
  return _fetchContent.apply(this, arguments);
}

function _fetchContent() {
  _fetchContent = _asyncToGenerator(function* (context, params) {
    const locale = context.state.i18n.currentLocale;

    try {
      const query = [Prismic.Predicates.at('document.type', params.type)];

      if (params.slug) {
        query.push(Prismic.Predicates.at("my.".concat(params.type, ".slug"), params.slug));
      }

      if (params.type === 'generic' && params.alias) {
        query.push(Prismic.Predicates.at("my.".concat(params.type, ".alias"), params.alias));
      }

      const endPoint = context.state.sharedEnv.payload.prismic;
      const api = yield Prismic.getApi(endPoint);
      const ref = getRef(context, api);
      const response = api.query(query, {
        lang: locale.iso ? locale.iso.toLowerCase() : '',
        ref
      });
      return response;
    } catch (e) {
      logError({
        msg: e
      });
      return null;
    }
  });
  return _fetchContent.apply(this, arguments);
}

function fetchDocumentsById(_x7, _x8) {
  return _fetchDocumentsById.apply(this, arguments);
}

function _fetchDocumentsById() {
  _fetchDocumentsById = _asyncToGenerator(function* (context, ids) {
    const locale = context.state.i18n.currentLocale;

    try {
      const endPoint = context.state.sharedEnv.payload.prismic;
      const api = yield Prismic.getApi(endPoint);
      const ref = getRef(context, api);
      const promises = [];
      ids.forEach(e => {
        const query = [Prismic.Predicates.at('document.id', e)];
        const response = api.query(query, {
          lang: locale.iso ? locale.iso.toLowerCase() : '',
          ref
        });
        promises.push(response);
      });
      const response = yield Promise.all(promises);
      return {
        results: response.map(e => e.results[0])
      };
    } catch (e) {
      logError({
        msg: e
      });
      return null;
    }
  });
  return _fetchDocumentsById.apply(this, arguments);
}

export { fetchContent, fetchDocumentsById, fetchArticlesByTag };